'use client'

import { ChakraProvider } from '@chakra-ui/react'
import { CacheProvider } from '@/utils/providers/cacheProvider'
import Fonts from '@/components/fonts/fonts'
import '@/styles/globals.scss'
import { theme } from '@/styles/theme'
import { ReactNode, useRef } from 'react'
import {
  ClientEnvironment,
  ClientEnvironmentContext,
} from '@/utils/globalConfig'
import {
  createQueryParametersStore,
  QueryParametersStoreContext,
} from '@/stores/queryParametersStore'
import { useSearchParams } from 'next/navigation'

export default function Providers({
  clientEnvironment,
  children,
}: {
  clientEnvironment: ClientEnvironment | undefined
  children: ReactNode
}) {
  const store = useRef(
    createQueryParametersStore(new URLSearchParams(useSearchParams())),
  ).current
  return (
    <ClientEnvironmentContext.Provider value={clientEnvironment}>
      <QueryParametersStoreContext.Provider value={store}>
        <CacheProvider>
          <ChakraProvider theme={theme}>
            <Fonts />
            {children}
          </ChakraProvider>
        </CacheProvider>
      </QueryParametersStoreContext.Provider>
    </ClientEnvironmentContext.Provider>
  )
}
